import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n/i18n';
import { theme } from 'styles/theme/theme';

/** `name` — только подпись в выборе фона; в базу уходит номер типа (`use-update-logo-background.ts`). */
export type Background = { name: MessageDescriptor; value: string };

export const backgroundColors: Record<number, Background> = {
  0: { name: msg`Прозрачный`, value: 'transparent' },
  1: { name: msg`Синий`, value: theme.colors.SurfaceRaisinBlack50 },
  2: { name: msg`Белый`, value: theme.colors.SurfaceWhite },
};

export const backgrounds: Background[] = [
  { name: msg`Прозрачный`, value: 'transparent' },
  { name: msg`Синий`, value: theme.colors.SurfaceRaisinBlack50 },
  { name: msg`Белый`, value: theme.colors.SurfaceWhite },
];
